export default __webpack_public_path__ + "static/media/71-helidrone.f33f38d7.png";